import { Link } from "react-router-dom";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { channels } from "@/mocks/siteData";

export default function ChannelGrid() {
  return (
    <section id="channels" className="w-full px-4 md:px-8 py-16 md:py-24">
      <div className="max-w-content mx-auto">
        <Reveal>
          <SectionHeading
            eyebrow="投稿通道"
            title="不同素材，走不同的通道"
            desc="文字、私信、视频、录音各有最合适的提交方式。选对通道，线索被核实和采纳的概率会明显提高。"
          />
        </Reveal>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-5">
          {channels.map((channel, index) => (
            <Reveal key={channel.id} delay={index * 80}>
              <Link
                to={`/channels#${channel.slug}`}
                className="group flex flex-col h-full p-6 md:p-7 rounded-lg border border-background-200 bg-background-50 hover:border-primary-300 hover:bg-background-100 transition-colors cursor-pointer"
              >
                <div className="flex items-start justify-between gap-4">
                  <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-100 text-primary-600 text-2xl">
                    <i className={channel.icon}></i>
                  </span>
                  <span className="px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                    {channel.tag}
                  </span>
                </div>
                <h3 className="mt-5 font-heading text-xl font-bold text-foreground-950 group-hover:text-primary-700 transition-colors">
                  {channel.name}
                </h3>
                <p className="mt-3 text-[15px] leading-relaxed text-foreground-600 flex-1">
                  {channel.summary}
                </p>
                <span className="mt-6 inline-flex items-center gap-2 text-sm font-medium text-primary-600">
                  进入通道
                  <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}